// const FALLBACK_API_URL = 'https://develop.api.edu.conjosa.com.br/api/';
const FALLBACK_API_URL = 'http://localhost:8000/api/';

declare global {
  interface Window {
    __APP_CONFIG__?: {
      API_URL?: string;
      SENTRY_DSN?: string;
      SENTRY_RELEASE?: string;
    };
  }
}

// Precedência:
//   1. window.__APP_CONFIG__  -> escrito em RUNTIME pelo entrypoint do
//      container a partir da env API_URL (public/config.js). É o caminho para
//      plataformas que não passam build args, como o Openship.
//   2. import.meta.env.VITE_API_URL -> build arg. Mantido para o CapRover e
//      para o docker compose, que já funcionam assim.
//   3. FALLBACK_API_URL -> dev local.
export const API_URL =
  window.__APP_CONFIG__?.API_URL ||
  import.meta.env.VITE_API_URL ||
  FALLBACK_API_URL;

// Mesma precedência do API_URL acima. O DSN de frontend não é segredo (só
// permite enviar evento, nunca ler dados), então tanto faz vir do build
// (VITE_SENTRY_DSN) ou de runtime (__APP_CONFIG__) — mas plataformas como o
// Openship só suportam a segunda via, daí precisar das duas.
export const SENTRY_DSN = window.__APP_CONFIG__?.SENTRY_DSN || import.meta.env.VITE_SENTRY_DSN || '';

export const SENTRY_RELEASE =
  window.__APP_CONFIG__?.SENTRY_RELEASE || import.meta.env.VITE_SENTRY_RELEASE || '';
